// extracted by mini-css-extract-plugin
module.exports = {"UseCaseAlternate":"styles_UseCaseAlternate__COas_"};